import { motion } from 'framer-motion';

export const Mascot = ({ className = "", size = 120 }) => {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
    >
      {/* Antenna */}
      <motion.circle
        cx="60"
        cy="12"
        r="6"
        fill="#FF6B6B"
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
      <rect x="57" y="15" width="6" height="10" fill="#7EC8C8" rx="2" />
      
      {/* Head */}
      <rect x="25" y="25" width="70" height="55" rx="16" fill="#7EC8C8" />
      
      {/* Face screen */}
      <rect x="32" y="32" width="56" height="41" rx="10" fill="#1A1A2E" />
      
      {/* Eyes */}
      <motion.g
        animate={{ scaleY: [1, 0.1, 1] }}
        transition={{ duration: 4, repeat: Infinity, repeatDelay: 2 }}
      >
        <circle cx="45" cy="52" r="8" fill="#F8F9FA" />
        <circle cx="75" cy="52" r="8" fill="#F8F9FA" />
        {/* Pupils */}
        <motion.circle
          cx="46"
          cy="53"
          r="4"
          fill="#1A1A2E"
          animate={{ x: [-1, 1, -1] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
        <motion.circle
          cx="76"
          cy="53"
          r="4"
          fill="#1A1A2E"
          animate={{ x: [-1, 1, -1] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </motion.g>
      
      {/* Smile */}
      <path
        d="M50 62 Q60 70 70 62"
        stroke="#4ECDC4"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      
      {/* Body */}
      <rect x="35" y="82" width="50" height="30" rx="10" fill="#7EC8C8" />
      
      {/* Body screen/chest */}
      <rect x="42" y="88" width="36" height="18" rx="6" fill="#1A1A2E" />
      
      {/* Heart on chest */}
      <motion.path
        d="M60 92 C56 89, 52 92, 52 95 C52 98, 60 103, 60 103 C60 103, 68 98, 68 95 C68 92, 64 89, 60 92Z"
        fill="#FF6B6B"
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 1, repeat: Infinity }}
      />
      
      {/* Arms */}
      <motion.rect
        x="15"
        y="85"
        width="16"
        height="8"
        rx="4"
        fill="#4ECDC4"
        animate={{ rotate: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        style={{ originX: 1, originY: 0.5 }}
      />
      <motion.rect
        x="89"
        y="85"
        width="16"
        height="8"
        rx="4"
        fill="#4ECDC4"
        animate={{ rotate: [0, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
        style={{ originX: 0, originY: 0.5 }}
      />
    </motion.svg>
  );
};

export const MascotSmall = ({ className = "" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="60" cy="12" r="6" fill="#FF6B6B" />
      <rect x="57" y="15" width="6" height="10" fill="#7EC8C8" rx="2" />
      <rect x="25" y="25" width="70" height="55" rx="16" fill="#7EC8C8" />
      <rect x="32" y="32" width="56" height="41" rx="10" fill="#1A1A2E" />
      <circle cx="45" cy="52" r="8" fill="#F8F9FA" />
      <circle cx="75" cy="52" r="8" fill="#F8F9FA" />
      <circle cx="46" cy="53" r="4" fill="#1A1A2E" />
      <circle cx="76" cy="53" r="4" fill="#1A1A2E" />
      <path d="M50 62 Q60 70 70 62" stroke="#4ECDC4" strokeWidth="3" strokeLinecap="round" fill="none" />
      <rect x="35" y="82" width="50" height="30" rx="10" fill="#7EC8C8" />
    </svg>
  );
};

export default Mascot;
